import { ApolloClient, InMemoryCache, ApolloLink } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from 'apollo-upload-client'

const defaultOptions = {
	watchQuery: {
		fetchPolicy: 'no-cache',
	},
	query: {
		fetchPolicy: 'no-cache',
	}
}

const prefix = process.env.NODE_ENV === 'development' ? 'http://' : 'https://'

const client = new ApolloClient({
    cache: new InMemoryCache({
        addTypename: false,
        typePolicies: {
            Query: {
                fields: {
                }
            }
        }
    }),
    link: ApolloLink.from([
        onError(({ graphQLErrors, networkError }) => {
            if (networkError) {
                console.log(`[Network error]: ${networkError}`);
            }

            if (graphQLErrors) {
                graphQLErrors.forEach(({ message, locations, path }) =>
                    console.log(
                        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                    )
                );
            }
        }),
        createUploadLink({
            uri: prefix + window.location.hostname + '/api',
            credentials: 'include',
        }),
    ]),
    defaultOptions,
});

export default client